export default __webpack_public_path__ + "static/media/note-chevron.4786ce39.svg";